// SSM DP5 Winder
import React from "react";
import { useMachineSetupContextState } from "./useMachineSetupContextState";
import {
   CommonRows, InputRangeRow, MinMaxRow, ProgramNameRow, RadioButtonRow, RadioLabelCol,
   RunTimeRow, SpeedStartToEndRow, WindingTensionRow,
} from "./index";

export default function MachineDP5() {
   const { machineSetup } = useMachineSetupContextState();
   return (
      <>
         <ProgramNameRow />
         <RunTimeRow />
         <InputRangeRow
            titleProp={"Tube OD"}
            descriptionProp={"in"}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={0.01}
            maxProp={9.99}
            propertyNameProp={"tubeOD"}
            errorDialogueProp={"0.01-9.99 only"}
            floatProp={true}
         />
         <InputRangeRow
            titleProp={"Yards Per Package"}
            descriptionProp={"yds"}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={1}
            maxProp={999999}
            propertyNameProp={"yardsPerPkg"}
            errorDialogueProp={"1-999,999 only"}
            floatProp={false}
         />
         <SpeedStartToEndRow />
         <InputRangeRow
            titleProp={"Traverse"}
            descriptionProp={"in"}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={0.01}
            maxProp={12.0}
            propertyNameProp={"traverse"}
            errorDialogueProp={"0.01-12.00 only"}
            floatProp={true}
         />
         <InputRangeRow
            titleProp={"Left Taper"}
            descriptionProp={"degrees"}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={1}
            maxProp={180}
            propertyNameProp={"leftTaper"}
            errorDialogueProp={"1-180 only"}
            floatProp={false}
         />
         <InputRangeRow
            titleProp={"Left Compensation"}
            descriptionProp={"%"}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={0}
            maxProp={99}
            propertyNameProp={"leftCompensation"}
            errorDialogueProp={"0-99 only"}
            floatProp={false}
         />
         <InputRangeRow
            titleProp={"Right Taper"}
            descriptionProp={"degrees"}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={1}
            maxProp={180}
            propertyNameProp={"rightTaper"}
            errorDialogueProp={"1-180 only"}
            floatProp={false}
         />
         <InputRangeRow
            titleProp={"Right Compensation"}
            descriptionProp={"%"}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={0}
            maxProp={99}
            propertyNameProp={"rightCompensation"}
            errorDialogueProp={"0-99 only"}
            floatProp={false}
         />
         <InputRangeRow
            titleProp={"Beginning Backpressure"}
            descriptionProp={""}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={1}
            maxProp={9999}
            propertyNameProp={"backPressureBegin"}
            errorDialogueProp={"1-9,999 only"}
            floatProp={false}
         />
         <InputRangeRow
            titleProp={"Ending Backpressure"}
            descriptionProp={""}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={1}
            maxProp={9999}
            propertyNameProp={"backPressureEnd"}
            errorDialogueProp={"1-9,999 only"}
            floatProp={false}
         />
         <RadioButtonRow
            promptRowSizeProp={3}
            valueRowSizeProp={4}
            titleProp={"Wind Type"}
            descriptionProp=""
         >
            <RadioLabelCol
               groupNameProp={"windTypeGroup"}
               valueProp={"Digiwind"}
               onChangeProp={"windType"}
               displayProp={"Digiwind"}
               stringProp
            />
            <RadioLabelCol
               groupNameProp={"windTypeGroup"}
               valueProp={"Precision"}
               onChangeProp={"windType"}
               displayProp={"Precision"}
               stringProp
            />
         </RadioButtonRow>
         {machineSetup.extendedPropertyJson?.windType === "Digiwind" && (
            <MinMaxRow
               titleProp={"Degrees"}
               descriptionProp=""
               minProp1={1}
               maxProp1={16}
               floatProp1={false}
               errorProp1={"1-16 only"}
               minProp2={1}
               maxProp2={16}
               floatProp2={false}
               errorProp2={"1-16 only"}
               valueProp1={"degreesStart"}
               valueProp2={"degreesEnd"}
               differentDisplayProp1={"Start:"}
               differentDisplayProp2={"End:"}
            />
         )}
         {machineSetup.extendedPropertyJson?.windType === "Precision" && (
            <MinMaxRow
               titleProp={"Wind Ratio"}
               descriptionProp=""
               minProp1={1.0}
               maxProp1={12.99999}
               floatProp1={true}
               errorProp1={"1-12.99999 only"}
               minProp2={1.0}
               maxProp2={12.99999}
               floatProp2={true}
               errorProp2={"1-12.99999 only"}
               valueProp1={"windRatioStart"}
               valueProp2={"windRatioEnd"}
               differentDisplayProp1={"Start:"}
               differentDisplayProp2={"End:"}
            />
         )}
         <WindingTensionRow windingTension />
         <CommonRows />
      </>
   );
}
